import Fieldset from '@/lib/models/fieldset';
import defineComponentModel from '@/lib/helpers/define-component-model';

const component = defineComponentModel(Fieldset, {
  props: {
    ui: {
      type: Object,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    presence: {
      type: Boolean,
      default: true,
    },

    blocker: {
      type: Boolean,
      default: false,
    },
  },

  customDataForModel() {
    return {
      presence: this.presence,
      blocker: this.blocker,
    };
  },
});

export default component;
